export function assertNonNull<T>(value: T | null): asserts value is T {
  if (value === null) {
    throw new Error('Expected non-null data but got null');
  }
}
